import "antd/dist/antd.css";
import React from "react";
import { Row, Col } from "antd";
import { useSelector } from "react-redux";
import ChangeProfilePassword from "./components/ChangePassword";
import MemberProfileDetail from "./components/ProfileDetails";
import SocialNetworks from "./components/SocialNetworks";
import SimpleHeader from "../../helpers/cards-helper/SimpleHeader";



const MemberLoggedProfile = () => {
    const memberId = useSelector((state) => state.Member.member_data.id);


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>
                <Row gutter={24} justifyContent="between">
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <SimpleHeader
                            title={"Profili im"}
                        />
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                        <MemberProfileDetail />
                    </Col>
                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                        <ChangeProfilePassword id={memberId} />
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <SocialNetworks id={memberId} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default MemberLoggedProfile;